<div style="height: 100%;width: 100%;overflow: auto;">
    <!-- <div>
        <form [formGroup]="createSetUpForm" (ngSubmit)="onViewClick()" style="align-items: center;">
            <div class="row" style="padding: 2px;">
                <div class="col-md-4 col-sm-6 col-6" style="padding: 0px 3px ;">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input style="cursor: pointer;" matInput [matDatepicker]="stickerView"
                                placeholder="From Date" (click)="stickerView.open()" [max]="currDate"
                                formControlName="fromDate" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="stickerView"></mat-datepicker-toggle>
                            <mat-datepicker #stickerView disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="col-md-4 col-sm-6 col-6" style="padding: 0px 3px ;">
                    <mat-card class="contain_card">
                        <mat-form-field>
                            <input style="cursor: pointer;" matInput [matDatepicker]="rickerView" placeholder="To Date"
                                (click)="rickerView.open()" [min]="createSetUpForm.controls['fromDate'].value"
                                [max]="currDate" formControlName="toDate" readonly required>
                            <mat-datepicker-toggle matSuffix [for]="rickerView"></mat-datepicker-toggle>
                            <mat-datepicker #rickerView disabled="false"></mat-datepicker>
                        </mat-form-field>
                    </mat-card>
                </div>

                <div class="col-md-4 col-sm-12 col-12" style="padding: 0px ;">
                    <button type="submit" id="btnnInsidePage">
                        VIEW<mat-icon class="icon-style">search</mat-icon>
                    </button>
                </div>

            </div>
        </form>
    </div>

    <div id="table_shipping_report">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
            style="width: max-content !important; min-width: 100%;">
            <caption></caption>

            <ng-container matColumnDef="date">
                <th scope="col" mat-header-cell *matHeaderCellDef> Date </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.date | date :
                    constant.dateTimeFormatForView}}</td>
                <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"></td>
            </ng-container>

            <ng-container matColumnDef="transNo">
                <th scope="col" mat-header-cell *matHeaderCellDef> Trans No. </th>
                <td mat-cell *matCellDef="let element" id="text_align">{{element.transNo}}</td>
                <td mat-footer-cell *matFooterCellDef style="color: white; border: none;"></td>
            </ng-container>

            <ng-container matColumnDef="debitAmount">
                <th scope="col" mat-header-cell *matHeaderCellDef> Dr Amount </th>
                <td mat-cell *matCellDef="let element" id="number_align">{{element.debitAmount | number : '1.2-2'}}</td>
                <td mat-footer-cell *matFooterCellDef id="number_align" style="color: white; border: none;">
                    {{totalDebitAmount | number : '1.2-2'}}</td>
            </ng-container>

            <ng-container matColumnDef="creditAmount">
                <th scope="col" mat-header-cell *matHeaderCellDef> Cr Amount </th>
                <td mat-cell *matCellDef="let element" id="number_align">{{element.creditAmount | number : '1.2-2'}}
                </td>
                <td mat-footer-cell *matFooterCellDef id="number_align" style="color: white; border: none;">
                    {{totalCreditAmount | number : '1.2-2'}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns ; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true;"></tr>
        </table>
    </div> -->

    <!-- <div style="height: 30px; background-color: #cde1ff; display: flex; padding-top: 5px; color: crimson;">
        <mat-icon>payment</mat-icon>
        <p style="padding-top: 1px;">Submit Bank details</p>
        <mat-icon>arrow_forward</mat-icon>
    </div>

    <div class="card shadow">
        <div style="height: 80%; padding: 4px;">
            <p style="font: .7em sans-serif;">&nbsp;* Settlement will be done at the end of the week</p>
            <p style="font: .9em sans-serif;">Total income of this week :</p>
        </div>
        <div style="height: 20%; padding: 0px 20px 0px 0px; display: flex; justify-content: flex-end;  color: #057f02;">
            <p style="font-size: 15px;">Withdrow</p>
            <mat-icon style="font-size: 23px !important;">arrow_right</mat-icon>
        </div>
    </div> -->

    <div style="display: flex;">
        <div type="button" style="margin-left: 2px;" (click)="divClick('Daily',toDate,toDate)" id="daily"
            class="btn btn-secondary btn-sm">Daily</div>
        <div type="button" style="margin-left: 2px;" (click)="divClick('Weekly',firstDayOfWeek,toDate)" id="weekly"
            class="btn btn-secondary btn-sm">Weekly</div>
        <div type="button" style="margin-left: 2px;" (click)="divClick('Monthly',fromDate,toDate)" id="monthly"
            class="btn btn-secondary btn-sm">Monthly</div>
    </div>

    <div style="padding-top: 3px;">
        <mat-card class="contain_card">
            <mat-form-field class="selectOption">
                <mat-select placeholder="Date Range" (selectionChange)="onFilterSelect($event.value)"
                    [(value)]="selectedValue">
                    <mat-option *ngFor="let type of filterData " [value]="type ">
                        {{type}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-card>
    </div>

    <div style="max-width: 100%; padding: 0px 10px;">
        <p style="margin-top: 10px;padding-left: 2px;"><b id="performanceHead">Today's performance</b></p>

        <div *ngIf="filteredData.length > 0; else noDataTemplate">
            <div *ngFor="let item of filteredData; let i = index" class="main-data-row"
                [ngStyle]="{'background-color': item.showDetails ? '#d3d3d3' : (i % 2 === 0 ? '#f0f0f0' : '#fff')}">
                <div class="data-row">
                    <div class="data-cell">
                        {{ item.date }}<br>
                        <p>Date</p>
                    </div>

                    <div class="data-cell">
                        {{ item.transNo }}<br>
                        <p>Trans No.</p>
                    </div>

                    <div class="data-cell">
                        {{ item.debitAmount }}<br>
                        <!-- <p>Debit Amount</p> -->
                        <p style="font-size: 23px; color: green; font-weight: 900;">↙</p>
                    </div>

                    <div class="data-cell">
                        {{ item.creditAmount | number : '1.2-2' }}<br>
                        <!-- <p>Credit Amount</p> -->
                        <p style="font-size: 23px; color: red; font-weight: 900;">↗</p>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #noDataTemplate>
            <div style="text-align: center; padding: 10px;">
                <img src="./assets/images/result-wrong-icon (1).svg" alt="" style=" height: 100px;">
                <p style="color: #cdcccc !important;">Nothing to show here</p>
            </div>
        </ng-template>
    </div>

    <div
        style="display: flex; padding-left: 2px; font-size: medium; padding-top: 8px; padding-bottom: 8px; margin: 10px 8px; border-radius: 5px; border: 1px solid #cdcccc;">
        <div style="width: 70%;">
            <b id="totDebit"> Total Debit Amount for today</b>
        </div>
        <div style="text-align: center;width: 30%;">
            <b>{{debitSumAmount}}</b>
        </div>
    </div>

    <div
        style="display: flex; padding-left: 2px; font-size: medium; padding-top: 8px; padding-bottom: 8px; margin: 10px 8px; border-radius: 5px; border: 1px solid #cdcccc;">
        <div style="width: 70%;">
            <b id="totCredit"> Total Credit Amount for today</b>
        </div>
        <div style="text-align: center;width: 30%;">
            <b>{{creditSumAmount}}</b>
        </div>
    </div>
</div>